import { Component, OnInit, HostBinding, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-button', // Your component selector
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.scss'], // Make sure to use .scss or .css correctly,
  standalone: false,
})
export class AppButtonComponent implements OnInit {
  private _color?: string;
  private _height?: string;
  private _width?: string;
  private _textColor?: string;
  private _borderRad?: string;
  private _opacity: Array<any> = [8, 7, 8];
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  @Input()
  set height(value: string | undefined) {
    this._height = value;
  }
  @Input() disabled: boolean = false;

  @Input()
  set width(value: string | undefined) {
    this._width = value;
  }
  @Input()
  set textColor(value: string | undefined) {
    this._textColor = value;
  }
  @Input()
  set borderRad(value: string | undefined) {
    this._borderRad = value;
  }
  @Input()
  set opacity(value: Array<any> | undefined) {
    this._opacity = value;
  }

  @HostBinding('style.--border-round')
  get borderRadius(): string | null {
    return this._borderRad ? `${this._borderRad}px` : '15px';
  }

  @HostBinding('style.--clear-color')
  get buttonClearColor(): string | null {
    if (this._opacity[0] >= 0 || this._opacity[0] <= 10) {
      switch (this._opacity[0]) {
        case 0:
          return this._color ? `hsl(var(--drop-color-${this._color})/0)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 1:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.1)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 2:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.2)` : 'hsl(var(--drop-color-primary)/0.2)';
          break;

        case 3:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
          break;

        case 4:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.4)` : 'hsl(var(--drop-color-primary)/0.4)';
          break;

        case 5:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.5)` : 'hsl(var(--drop-color-primary)/0.5)';
          break;

        case 6:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.6)` : 'hsl(var(--drop-color-primary)/0.6)';
          break;

        case 7:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.7)` : 'hsl(var(--drop-color-primary)/0.7)';
          break;

        case 8:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.8)` : 'hsl(var(--drop-color-primary)/0.8)';
          break;

        case 9:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.9)` : 'hsl(var(--drop-color-primary)/0.9)';
          break;

        case 10:
          return this._color ? `hsl(var(--drop-color-${this._color})/1)` : 'hsl(var(--drop-color-primary)/1)';
          break;

        default:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
      }
    }
  }
  @HostBinding('style.--clear2-color')
  get buttonClear2Color(): string | null {
    if (this._opacity[1] >= 0 || this._opacity[1] <= 10) {
      switch (this._opacity[1]) {
        case 0:
          return this._color ? `hsl(var(--drop-color-${this._color})/0)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 1:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.1)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 2:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.2)` : 'hsl(var(--drop-color-primary)/0.2)';
          break;

        case 3:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
          break;

        case 4:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.4)` : 'hsl(var(--drop-color-primary)/0.4)';
          break;

        case 5:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.5)` : 'hsl(var(--drop-color-primary)/0.5)';
          break;

        case 6:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.6)` : 'hsl(var(--drop-color-primary)/0.6)';
          break;

        case 7:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.7)` : 'hsl(var(--drop-color-primary)/0.7)';
          break;

        case 8:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.8)` : 'hsl(var(--drop-color-primary)/0.8)';
          break;

        case 9:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.9)` : 'hsl(var(--drop-color-primary)/0.9)';
          break;

        case 10:
          return this._color ? `hsl(var(--drop-color-${this._color})/1)` : 'hsl(var(--drop-color-primary)/1)';
          break;

        default:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
      }
    }
  }
  @HostBinding('style.--clear3-color')
  get buttonClear3Color(): string | null {
    if (this._opacity[2] >= 0 || this._opacity[2] <= 10) {
      switch (this._opacity[2]) {
        case 0:
          return this._color ? `hsl(var(--drop-color-${this._color})/0)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 1:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.1)` : 'hsl(var(--drop-color-primary)/0.1)';
          break;
        case 2:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.2)` : 'hsl(var(--drop-color-primary)/0.2)';
          break;

        case 3:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
          break;

        case 4:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.4)` : 'hsl(var(--drop-color-primary)/0.4)';
          break;

        case 5:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.5)` : 'hsl(var(--drop-color-primary)/0.5)';
          break;

        case 6:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.6)` : 'hsl(var(--drop-color-primary)/0.6)';
          break;

        case 7:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.7)` : 'hsl(var(--drop-color-primary)/0.7)';
          break;

        case 8:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.8)` : 'hsl(var(--drop-color-primary)/0.8)';
          break;

        case 9:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.9)` : 'hsl(var(--drop-color-primary)/0.9)';
          break;

        case 10:
          return this._color ? `hsl(var(--drop-color-${this._color})/1)` : 'hsl(var(--drop-color-primary)/1)';
          break;

        default:
          return this._color ? `hsl(var(--drop-color-${this._color})/0.3)` : 'hsl(var(--drop-color-primary)/0.3)';
      }
    }
  }

  @HostBinding('style.--button-color')
  get buttonColor(): string | null {
    return this._color ? `var(--drop-color-${this._color})` : '0 0 0';
  }
  @HostBinding('style.--text-color')
  get fontColor(): string | null {
    return this._textColor ? `var(--ion-text-${this._textColor})` : `var(--ion-text-${this._color})`;
  }
  @HostBinding('style.--height')
  get heightBtn(): string | null {
    return this._height ? `${this._height}vw` : '5vh';
  }
  @HostBinding('style.--width')
  get widthBtn(): string | null {
    return this._width ? `${this._width}vw` : '';
  }
  // HostBinding to apply classes to the component's host element directly
  @HostBinding('class.is-hovered')
  isHovered: boolean = false;

  @HostBinding('class.is-active')
  isActive: boolean = false;

  // Output event for button clicks
  @Output()
  buttonClick = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  // --- Event Handlers for Mouse and Touch ---

  onPointerEnter(): void {
    if (!this.disabled) {
      this.isHovered = true;
      this.isActive = false;
    }
  }

  onPointerLeave(): void {
    if (!this.disabled) {
      this.isHovered = false;
      this.isActive = false;
    }
  }

  onPointerDown(): void {
    if (!this.disabled) {
      this.isActive = false;
      this.isHovered = true;
    }
  }

  onPointerUp(): void {
    if (!this.disabled) {
      this.isActive = true;
      this.isHovered = false;
      // Note: isHovered is handled by the leave event if the pointer moves away
    }
  }

  onClick(): void {
    if (!this.disabled) {
      this.buttonClick.emit();
    }
    // You can remove these lines if onPointerUp already handles it.
    this.isActive = false;
    this.isHovered = false;
  }
}
